import { useQuery } from "@tanstack/react-query";
import type { SellerOptionsResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useSellerOptionsQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.sellerOptions(),
    queryFn: () =>
      apiJsonClient<SellerOptionsResponse>(endpoints.admin.sellerOptions),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
